import React from 'react';

interface ErrorLabelProps {
  label?: string;
}

export const ErrorLabel: React.FC<ErrorLabelProps> = ({ label }) => {
  if (!label) return null;
  return (
    <div className="field-error-label">
      <i className="icon-exclamation-outline" />
      {label}
    </div>
  );
};
